import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from 'antd';
import { ALIMTALK_EXPIRE_ISSUED_COUNT } from '../../../constants/service/app/alimtalkConstants';
// V1 coupon/list 응답의 periodType은 숫자 코드 — 레거시 정본 상수 재사용
import { COUPON_PERIOD_TYPE } from '../../../constants/service/app/couponConstants';
import { AlimtalkSendFormValues } from '../../../types/alimtalk/form';
import { CouponPickerModal } from './CouponPickerModal';
import { useCouponRows } from './useCouponRows';
import * as Styled from './style';

export const CouponExpireSection = () => {
  const { setValue } = useFormContext<AlimtalkSendFormValues>();
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  // 우선순위 = 배열 순서 (§9.3). 발급이 아니지만 백엔드 @Min(1) 제약으로 issuedCount는 1 고정(워커 미사용).
  // 만료는 알림톡 쿠폰/유효기간을 따로 고르지 않으므로, 미리보기 대표값 = 최우선(첫 번째) 쿠폰.
  // 유효기간은 쿠폰 자체에서 가져오되, 단일 절대 날짜가 있는 '날짜 지정' 타입만 표시한다.
  // (발급일 기준=유저별, 무기한=날짜 없음 → 미리보기는 placeholder)
  const { rows, addCoupons, removeCoupon, moveCoupon } = useCouponRows({
    defaultIssuedCount: ALIMTALK_EXPIRE_ISSUED_COUNT,
    onRowsChange: (next) => {
      const top = next[0];
      setValue('previewCouponName', top?.name ?? null);
      const hasFixedDate = top?.periodType === COUPON_PERIOD_TYPE.START_AND_END_DATE;
      setValue('previewStartDate', hasFixedDate ? top.startDate : null);
      setValue('previewEndDate', hasFixedDate ? top.endDate : null);
    },
  });

  return (
    <Styled.Section>
      <Styled.SectionTitle>만료 쿠폰 (우선순위 순서)<Styled.RequiredMark>*</Styled.RequiredMark></Styled.SectionTitle>

      <Styled.SelectedList>
        {rows.length === 0 && <Styled.EmptyText>선택된 쿠폰이 없습니다.</Styled.EmptyText>}
        {rows.map((row, index) => (
          <Styled.SelectedRow key={row.couponId}>
            <Styled.PriorityIndex>{index + 1}</Styled.PriorityIndex>
            <Styled.SelectedName>
              {row.name} <Styled.IdBadge>#{row.couponId}</Styled.IdBadge>
            </Styled.SelectedName>
            <Button size="small" disabled={index === 0} onClick={() => moveCoupon(index, -1)}>
              ↑
            </Button>
            <Button size="small" disabled={index === rows.length - 1} onClick={() => moveCoupon(index, 1)}>
              ↓
            </Button>
            <Button danger size="small" onClick={() => removeCoupon(row.couponId)}>
              삭제
            </Button>
          </Styled.SelectedRow>
        ))}
      </Styled.SelectedList>

      <Button onClick={() => setIsPickerOpen(true)}>＋ 쿠폰 추가</Button>

      <CouponPickerModal open={isPickerOpen} onClose={() => setIsPickerOpen(false)} onConfirm={addCoupons} />
    </Styled.Section>
  );
};
